(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[312],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(81240),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 93386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseRest = __webpack_require__(5976),
    baseUniq = __webpack_require__(45652),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),

/***/ 11430:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/dynamic-template-page",
      function () {
        return __webpack_require__(33325);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_addons_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/ouibounce/build/ouibounce.js
var ouibounce = __webpack_require__(5499);
var ouibounce_default = /*#__PURE__*/__webpack_require__.n(ouibounce);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-constants.js
var EXIT_POPUP_TEXT = {
    en: {
        TITLE: '"I want to hug the people that created this."',
        SUBTITLE: "- Emma J Coulson, with monday.com since 2014",
        SIGNUP_HEADER_TEXT: "Join 15,000+ teams who are passionate about monday.com",
        SIGNUP_INPUT_PLACEHOLDER: "Enter your work email",
        SIGNUP_BUTTON_TEXT: "Get free access now",
        SIGNUP_FOOTER_TEXT: "No thanks"
    },
    fr: {
        TITLE: "Vous n'avez pas le temps... Nous comprenons :)",
        SUBTITLE: "Envoyez-vous une invitation maintenant, et d\xe9butez quand vous avez 3 minutes",
        SIGNUP_INPUT_PLACEHOLDER: "Entrez votre adresse e-mail",
        SIGNUP_BUTTON_TEXT: "m'inviter"
    },
    es: {
        TITLE: "Est\xe1s ocupado... Te entendemos :)",
        SUBTITLE: "Env\xedate una invitaci\xf3n ahora y prueba monday.com cuando tengas 3 minutos",
        SIGNUP_INPUT_PLACEHOLDER: "Ingresa tu correo laboral",
        SIGNUP_BUTTON_TEXT: "Enviar"
    },
    de: {
        TITLE: "Du bist besch\xe4ftigt… wir verstehen das :)",
        SUBTITLE: "Sende dir jetzt selbst eine Einladung und probiere uns aus, wenn 3 Minuten Zeit hast",
        SIGNUP_INPUT_PLACEHOLDER: "Ihre Firmen-E-Mail-Adresse",
        SIGNUP_BUTTON_TEXT: "Mich selbst einladen"
    },
    it: {
        TITLE: "Sei impegnato... ti capiamo :)",
        SUBTITLE: "Mandati un auto-invito, e mettici alla prova quando hai 3 minuti liberi",
        SIGNUP_INPUT_PLACEHOLDER: "Inserisci la tua email aziendale",
        SIGNUP_BUTTON_TEXT: "Invita Me Stesso"
    }
};
var EXIT_POPUP_ORIGIN = "hp_exit_intent_modal";

// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.scss.js



var StyledModalBackgroundComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ebjt820"
})("position:fixed;width:100%;height:100%;background-color:", colors/* default.black */.Z.black, ";opacity:0.9;top:0;left:0;z-index:", z_index/* MODAL_BACKGROUND */.AE, ";");

;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.js


var ModalBackgroundComponent = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBackgroundComponent, {
        className: "modal-background",
        onClick: onClick
    });
};
/* harmony default export */ var modal_background_component = (ModalBackgroundComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.scss.js


var componentStyle = new String(".header-text.jsx-fb833f46e36abbce{margin-bottom:16px}");
componentStyle.__hash = "fb833f46e36abbce";
var signupBoxStyle = new String(".exit-popup-signup{.footer-text{cursor:pointer;color:darken(#fff,10%)}.exit-popup-signup-box{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.signup-form{margin-bottom:16px;margin-top:0}.signup-input{height:56px;width:224px;padding:0 24px;-webkit-border-radius:50px 0 0 50px;-moz-border-radius:50px 0 0 50px;border-radius:50px 0 0 50px;border:1px solid transparent;margin-right:0;color:".concat(colors/* default.black */.Z.black, ";vertical-align:bottom;font-size:.875rem;&:focus{outline:0}}.signup-button{height:56px;min-width:200px;background:#f4ce2f;-webkit-border-radius:0 50px 50px 0;-moz-border-radius:0 50px 50px 0;border-radius:0 50px 50px 0;border:1px solid transparent;padding:0 10px;color:#333;font-size:.875rem;vertical-align:bottom;&:hover{background:darken(#f4ce2f,5%);border:#f4ce2f}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.exit-popup-signup{.exit-popup-signup-box .signup-form-core-component-wrapper form{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;.signup-button-wrapper{width:auto;padding:8px 0 16px 0}}}}"));
signupBoxStyle.__hash = "98a26903dd2c2d5b";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.js











var ExitPopupSignup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupSignup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupSignup);
    function ExitPopupSignup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopupSignup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            value: ""
        };
        _this.onInputChange = _this.onInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopupSignup, [
        {
            key: "onInputChange",
            value: function onInputChange(e) {
                var value = e.target.value.value;
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerText = _props.headerText, inputPlaceholder = _props.inputPlaceholder, buttonText = _props.buttonText, footerText = _props.footerText, origin = _props.origin, onClickFooterText = _props.onClickFooterText;
                var value = this.state.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup",
                    children: [
                        headerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "header-text",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: inputPlaceholder,
                                ctaText: buttonText,
                                useCtaText: !!buttonText,
                                origin: origin,
                                forceDefaultForm: true
                            })
                        }),
                        footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: onClickFooterText,
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyle.__hash,
                            children: componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: signupBoxStyle.__hash,
                            children: signupBoxStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupSignup;
}(react.PureComponent);

ExitPopupSignup.defaultProps = {
    headerText: "Join <monday-paying-companies />+ teams who are passionate about monday.com",
    buttonText: "Get free access now",
    inputPlaceholder: "Enter your work email",
    footerText: "No thanks"
};

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.scss.js


var exit_popup_content_component_scss_componentStyle = new String(".exit-popup-content-component.jsx-c4034e412f97cb55{position:fixed;z-index:".concat(z_index/* MODAL_BACKGROUND */.AE + 1, ";left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:720px;padding:56px 40px 40px 40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background:#333;color:#fff;text-align:center;.content-title.jsx-c4034e412f97cb55{font-size:3vw;font-weight:500;margin:0}.content-subtitle.jsx-c4034e412f97cb55{font-size:1.2vw;margin-bottom:56px}}"));
exit_popup_content_component_scss_componentStyle.__hash = "c4034e412f97cb55";
var closeIconStyle = new String(".exit-popup-close.jsx-76784fb04befc36c{position:absolute;top:0;right:0;width:60px;height:60px;background:-webkit-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-moz-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-o-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);-webkit-border-radius:0px 0px 0px 5px;-moz-border-radius:0px 0px 0px 5px;border-radius:0px 0px 0px 5px;.x-button.jsx-76784fb04befc36c{position:absolute;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg);top:-4px;right:4px;line-height:1;font-size:2.25rem;color:#787878;-webkit-transition:color.1s ease-in-out;-moz-transition:color.1s ease-in-out;-o-transition:color.1s ease-in-out;transition:color.1s ease-in-out;text-decoration:none;cursor:pointer;&.jsx-76784fb04befc36c:hover,&.jsx-76784fb04befc36c:active,&.jsx-76784fb04befc36c:focus{color:#c4c4c4;text-decoration:none}}}");
closeIconStyle.__hash = "76784fb04befc36c";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.js









var ExitPopupContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupContent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupContent);
    function ExitPopupContent() {
        (0,_class_call_check/* default */.Z)(this, ExitPopupContent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ExitPopupContent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupHeaderText = _props.signupHeaderText, singupInputPlaceholder = _props.singupInputPlaceholder, signupButtonText = _props.signupButtonText, signupFooterText = _props.signupFooterText, onClose = _props.onClose, origin = _props.origin;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "nofollow",
                                onClick: onClose,
                                className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "x-button pointer tc",
                                children: "+"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-subtitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupSignup, {
                            headerText: signupHeaderText,
                            inputPlaceholder: singupInputPlaceholder,
                            buttonText: signupButtonText,
                            footerText: signupFooterText,
                            onClickFooterText: onClose,
                            origin: origin
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: exit_popup_content_component_scss_componentStyle.__hash,
                            children: exit_popup_content_component_scss_componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: closeIconStyle.__hash,
                            children: closeIconStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupContent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/localized-number-of-customers.js
var localized_number_of_customers = __webpack_require__(2522);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-component.js


















var ExitPopup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopup);
    function ExitPopup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isOpen: false
        };
        _this._ouibounce = null;
        _this.onExitIntent = _this.onExitIntent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClose = _this.onClose.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopup, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initOuibounce();
            }
        },
        {
            key: "initOuibounce",
            value: function initOuibounce() {
                var _props = this.props, timer = _props.timer, aggressive = _props.aggressive, sensitivity = _props.sensitivity, delay = _props.delay, cookieExpire = _props.cookieExpire, cookieDomain = _props.cookieDomain, cookieName = _props.cookieName;
                this._ouibounce = ouibounce_default()(false, {
                    timer: timer,
                    aggressive: aggressive,
                    sensitivity: sensitivity,
                    delay: delay,
                    cookieExpire: cookieExpire,
                    cookieDomain: cookieDomain,
                    cookieName: cookieName,
                    callback: this.onExitIntent
                });
            }
        },
        {
            key: "onExitIntent",
            value: function onExitIntent() {
                var abTests = this.props.abTests;
                if (!(0,acquisition_ab_test_service.shouldSeeReviveExitPopupAbTest)(abTests, true)) return;
                this.props.onExitIntentCallback && this.props.onExitIntentCallback();
                this.setState({
                    isOpen: true
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_OPEN);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.props.onCloseExitPopupCallback && this.props.onCloseExitPopupCallback();
                this.setState({
                    isOpen: false
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_CLOSE);
            }
        },
        {
            key: "render",
            value: function render() {
                var isOpen = this.state.isOpen;
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupConfig = _props.signupConfig, translate = _props.translate, translateWithParam = _props.translateWithParam, localeId = _props.localeId;
                var titleToUse = title || translate("exitPopup.title");
                var subtitleToUse = subtitle || translate("exitPopup.subtitle");
                var signupHeaderTextToUse = signupConfig && signupConfig.headerText || translateWithParam("exitPopup.signupTitle", (0,localized_number_of_customers/* getLocalizedNumberOfPayingTeams */.i)(localeId));
                var inputPlaceholderToUse = signupConfig && signupConfig.inputPlaceholder || translate("exitPopup.signupInputPlaceholder");
                var buttonTextToUse = signupConfig && signupConfig.buttonText || translate("exitPopup.signupButtonText");
                var footerTextToUse = signupConfig && signupConfig.footerText || translate("exitPopup.footerText");
                return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "exit-popup-overlay",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_background_component, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupContent, {
                            title: titleToUse,
                            subtitle: subtitleToUse,
                            signupHeaderText: signupHeaderTextToUse,
                            singupInputPlaceholder: inputPlaceholderToUse,
                            signupButtonText: buttonTextToUse,
                            signupFooterText: footerTextToUse,
                            onClose: this.onClose,
                            origin: EXIT_POPUP_ORIGIN
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
            }
        }
    ]);
    return ExitPopup;
}(react.PureComponent);
ExitPopup.defaultProps = {
    timer: 100,
    aggressive: false,
    sensitivity: 5,
    delay: 200,
    cookieExpire: 30,
    cookieDomain: ".monday.com",
    cookieName: cookies.VIEWED_OUI_BOUNCE_MODAL_COOKIE
};
/* harmony default export */ var exit_popup_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(ExitPopup)));

// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
;// CONCATENATED MODULE: ./components/addons/core-addons/core-addons-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var CoreAddonsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CoreAddonsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CoreAddonsComponent);
    function CoreAddonsComponent() {
        (0,_class_call_check/* default */.Z)(this, CoreAddonsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CoreAddonsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                //TODO: Remove and change GTM trigger to page load
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SHOW_COOKIEHUB_DIALOG_EVENT_NAME);
            //If we see that CookieHub Geolocation isn't working well we can fire a GTM event only for relevant countries + another for the rest to launch all cookies
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, exitPopupConfig = _props.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: exitPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(exit_popup_component, _object_spread({}, exitPopupConfig))
                });
            }
        }
    ]);
    return CoreAddonsComponent;
}(react.PureComponent);
/* harmony default export */ var core_addons_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(CoreAddonsComponent)));


/***/ }),

/***/ 14759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "l": function() { return /* binding */ buttonThemes; }
/* harmony export */ });
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);

var buttonThemes = {
    iris: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].iris */ .Z.iris,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    black: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    white: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud
    }
};
// PLAY BUTTON SIZES
var MD = "md";
var LG = "lg";


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var services_localization_localization_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99952);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75422);
/* harmony import */ var server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_5__);










var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 33325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ DynamicTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var components_templates_dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33530);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var DynamicTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DynamicTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(DynamicTemplatePage);
    function DynamicTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, DynamicTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(DynamicTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_templates_dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return DynamicTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_3__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 83971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ LOGO_COMPANY_FIELDS; },
/* harmony export */   "WX": function() { return /* binding */ SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS; },
/* harmony export */   "X$": function() { return /* binding */ NUMBER_OF_COMPANIES; },
/* harmony export */   "kZ": function() { return /* binding */ LOGO_COMPANY_COUNTRIES; },
/* harmony export */   "ly": function() { return /* binding */ SUPPORTED_LOGOS_NUMBER_OPTIONS; },
/* harmony export */   "yA": function() { return /* binding */ getCompaniesAssets; }
/* harmony export */ });
/* unused harmony exports ISO2_TO_LOGO_COUNTRIES_MAP, getPersonalizedLogosByVisitorCountryIfNeeded */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var lodash_union__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93386);
/* harmony import */ var lodash_union__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_union__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85010);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__);




// in cloudinarry, upload both to staging and production (so you'll be able to test first)
var SUPPORTED_LOGOS_NUMBER_OPTIONS = [
    "5",
    "7",
    "9",
    "10",
    "12",
    "15",
    "18",
    "20"
];
var SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS = [
    "5",
    "7",
    "9",
    "10",
    "12",
    "15",
    "18",
    "20"
];
var LOGO_COMPANY_FIELDS = {
    GENERAL: "General",
    GENERAL_WHITE: "General (white)",
    GENERAL_BLACK: "General (black)",
    GENERAL_OLD: "General_Old",
    HEALTHCARE: "Healthcare",
    ENTERTAINMENT: "Entertainment",
    MARKETING: "Marketing",
    ENTERPRISE: "Enterprise",
    SOFTWARE: "Software",
    CONSTRUCTION: "Construction",
    RETAIL: "Retail",
    CRM: "CRM"
};
var LOGO_COMPANY_COUNTRIES = {
    AUSTRALIA: "Australia",
    BRAZIL: "Brazil",
    FRANCE: "France",
    GERMANY: "Germany",
    ITALY: "Italy",
    JAPAN: "Japan",
    MEXICO: "Mexico",
    NETHERLANDS: "Netherlands",
    SEA: "SEA (South East Asia)",
    UK: "UK",
    SWITZERLAND: "Switzerland"
};
var _obj;
var ISO2_TO_LOGO_COUNTRIES_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.UNITED_KINGDOM_ISO2, LOGO_COMPANY_COUNTRIES.UK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.AUSTRALIA_ISO2, LOGO_COMPANY_COUNTRIES.AUSTRALIA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.PHILIPPINES_ISO2, LOGO_COMPANY_COUNTRIES.SEA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.SINGAPORE_ISO2, LOGO_COMPANY_COUNTRIES.SEA), _obj);
var Uber = {
    url: "/static/img/customers/logos-v2/uber.png",
    name: "Uber"
};
// const Adobe = {
//   url: "/static/img/customers/logos-v2/adobe.png",
//   name: "Adobe"
// };
var UniversalMusicGroup = {
    url: "/static/img/customers/logos-v2/universal.png",
    name: "Universal Music Group"
};
var UniversalMusicGroupWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/universal.png",
    name: "Universal Music Group"
};
var UniversalMusicGroupBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/universal.png",
    name: "Universal Music Group"
};
// const Hulu = {
//   url: "/static/img/customers/logos-v2/hulu.png",
//   name: "Hulu"
// };
// const Unilever = {
//   url: "/static/img/customers/logos-v2/unilever.png",
//   name: "Unilever"
// };
// const Abbott = {
//   url: "/static/img/customers/logos-v2/abbott.png",
//   name: "Abbott"
// };
var Genpact = {
    url: "/static/img/customers/logos-v2/genpact.png",
    name: "Genpact"
};
// const Humana = {
//   url: "/static/img/customers/logos-v2/humana.png",
//   name: "Humana"
// };
var FrontierDevelopments = {
    url: "/static/img/customers/logos-v2/frontier-developments-seeklogo.png",
    name: "Frontier Developments"
};
var Zippo = {
    url: "/static/img/customers/logos-v2/Retail_Zippo.png",
    name: "Zippo"
};
var Alexion = {
    url: "/static/img/customers/logos-v2/alexion.png",
    name: "Alexion"
};
var Anadarko = {
    url: "/static/img/customers/logos-v2/anadarko.png",
    name: "Anadarko"
};
// const Gameloft = {
//   url: "/static/img/customers/logos-v2/gameloft.png",
//   name: "Gameloft"
// };
var Spinmaster = {
    url: "/static/img/customers/logos-v2/spinmaster.png",
    name: "Spinmaster"
};
var InteriorLogic = {
    url: "/static/img/customers/logos-v2/interior_logic.png",
    name: "Interior Logic"
};
var AmericanFamilyInsurance = {
    url: "/static/img/customers/logos-v2/american_family_insurance.png",
    name: "American Family Insurance"
};
var Deezer = {
    url: "/static/img/customers/logos-v2/deezer.png",
    name: "Deezer"
};
var Barvado = {
    url: "/static/img/customers/logos-v2/barvado.png",
    name: "Barvado"
};
var Briggs = {
    url: "/static/img/customers/logos-v2/briggs_stratton_corporation.png",
    name: "Briggs"
};
var CarndoChemrisk = {
    url: "/static/img/customers/logos-v2/cardno_chemrisk.png",
    name: "Carndo Chemrisk"
};
// const ReiCom = { url: "/static/img/customers/logos-v2/rei.com.png", name: "Reicom" };
var AeroMexico = {
    url: "/static/img/customers/logos-v2/aeromexico.png",
    name: "Aero Mexico"
};
var ProcoreTechnology = {
    url: "/static/img/customers/logos-v2/procore_technology.png",
    name: "Procore Technology"
};
// const FoxNews = { url: "/static/img/customers/logos-v2/fox_news.png", name: "Fox News" };
// const AllState = { url: "/static/img/customers/logos-v2/allstate.png", name: "Allstate" };
var Outbrain = {
    url: "/static/img/customers/logos-v2/outbrain.png",
    name: "Outbrain"
};
// const Delta = { url: "/static/img/customers/logos-v2/delta.png",  name: "Delta" };
var Emerson = {
    url: "/static/img/customers/logos-v2/emerson.png",
    name: "Emerson"
};
var CardinalHealth = {
    url: "/static/img/customers/logos-v2/cardinal_health.png",
    name: "Cardinal Health"
};
// const IBM = { url: "/static/img/customers/logos-v2/ibm.png",  name: "IBOM" };
// const WeWork = { url: "/static/img/customers/logos-v2/wework.png",  name: "WeWork" };
// const MITFederalCredit = {
//   url: "/static/img/customers/logos-v2/mit_federal_credit_union.png",
//   name: "MIT Federal Credit"
// };
var Marriott = {
    url: "/static/img/customers/logos-v2/marriott.png",
    name: "Marriott"
};
var Mckesson = {
    url: "/static/img/customers/logos-v2/mckesson.png",
    name: "Mckesson"
};
// const Corning = { url: "/static/img/customers/logos-v2/corning.png", name: "Corning" };
// const Tesla = { url: "/static/img/customers/logos-v2/tesla.png", name: "Tesla" };
// const Naic = { url: "/static/img/customers/logos-v2/naic.png", name: "Naic" };
// const Paypal = {
//   url: "/static/img/customers/logos-v2/paypal.png",
//   name: "Paypal"
// };
var Glossier = {
    url: "/static/img/customers/logos-v2/glossier.png",
    name: "Glossier"
};
var GlossierWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/glossier.png",
    name: "Glossier"
};
var GlossierBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/glossier.png",
    name: "Glossier"
};
var Kroger = {
    url: "/static/img/customers/logos-v2/kroger.png",
    name: "Kroger"
};
var Walmart = {
    url: "/static/img/customers/logos-v2/walmart.png",
    name: "Walmart"
};
var NipponOil = {
    url: "/static/img/customers/logos-v2/nippon_oil_corporation.png",
    name: "NipponOil"
};
// const Visa = {
//   url: "/static/img/customers/logos-v2/visa.png",
//   name: "Visa"
// };
// const CultureTrip = {
//   url: "/static/img/customers/logos-v2/culture_trip.png",
//   name: "Culture Trip"
// };
// const ClasenChocolate = {
//   url: "/static/img/customers/logos-v2/clasen_of_chocolate.png",
//   name: "Clasen Chocolate"
// };
// const Aecom = { url: "/static/img/customers/logos-v2/aecom.png", name: "Aecom" };
var ADP = {
    url: "/static/img/customers/logos-v2/adp.png",
    name: "ADP"
};
var BD = {
    url: "/static/img/customers/logos-v2/bd.png",
    name: "BD"
};
var BDWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/bd.png",
    name: "BD"
};
var BDBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/bd.png",
    name: "BD"
};
var HCAHealthcare = {
    url: "/static/img/customers/logos-v2/hca_healthcare.png",
    name: "HCA Healthcare"
};
var Peloton = {
    url: "/static/img/customers/logos-v2/peloton.png",
    name: "Peloton"
};
var TennisAustralia = {
    url: "/static/img/customers/logos-v2/tennis_australia.png",
    name: "Tennis Australia"
};
// const CBRE = { url: "/static/img/customers/logos-v2/cbre.png", name: "CBRE" };
var Exelon = {
    url: "/static/img/customers/logos-v2/exelon.png",
    name: "Exelon"
};
var HenrySchein = {
    url: "/static/img/customers/logos-v2/henry_schein.png",
    name: "Henry Schein"
};
var Davita = {
    url: "/static/img/customers/logos-v2/davita.png",
    name: "Davita"
};
// const Oneok = { url: "/static/img/customers/logos-v2/oneok.png", name: "Oneok" };
// const Parker = { url: "/static/img/customers/logos-v2/parker.png", name: "Parker" };
var PVH = {
    url: "/static/img/customers/logos-v2/Retail_PVH.png",
    name: "PVH"
};
// const Sempra = { url: "/static/img/customers/logos-v2/sempra.png", name: "Sampra" };
var Stryker = {
    url: "/static/img/customers/logos-v2/stryker.png",
    name: "Stryker"
};
var ThermoFisher = {
    url: "/static/img/customers/logos-v2/thermo_fisher.png",
    name: "Thermo Fisher"
};
var Univar = {
    url: "/static/img/customers/logos-v2/univar.png",
    name: "Univar"
};
var UsFoods = {
    url: "/static/img/customers/logos-v2/us_foods.png",
    name: "UsFoods"
};
var WestRock = {
    url: "/static/img/customers/logos-v2/westrock.png",
    name: "WestRock"
};
// const YUM = { url: "/static/img/customers/logos-v2/yum.png", name: "YUM" };
var Caseys = {
    url: "/static/img/customers/logos-v2/caseys.png",
    name: "Caseys"
};
// const Ascential = { url: "/static/img/customers/logos-v2/ascential.png", name: "Ascential" };
var CrossRiverBank = {
    url: "/static/img/customers/logos-v2/cross_river_bank.png",
    name: "Cross River Bank"
};
var PrimonialHolding = {
    url: "/static/img/customers/logos-v2/primonial_holding.png",
    name: "Primonial Holding"
};
var Prohibition_vapes = {
    url: "/static/img/customers/logos-v2/prohibition_vapes.png",
    name: "Prohibition Vapes"
};
var AlbericiGroup = {
    url: "/static/img/customers/logos-v2/alberici_group.png",
    name: "Alberic Group"
};
var UniversityOfLouisville = {
    url: "/static/img/customers/logos-v2/university_of_louisville.png",
    name: "University Of Louisville"
};
var GamingLabs = {
    url: "/static/img/customers/logos-v2/gaming_labs.png",
    name: "Gaming Labs"
};
var Terracon = {
    url: "/static/img/customers/logos-v2/terracon.png",
    name: "Terracon"
};
var VeriskAnalytics = {
    url: "/static/img/customers/logos-v2/verisk_analytics.png",
    name: "Verisk Analytics"
};
// const GuidWellSource = {
//   url: "/static/img/customers/logos-v2/guidewell_source.png",
//   name: "GuideWell Source"
// };
var CushmanAndWakefield = {
    url: "/static/img/customers/logos-v2/cushman_and_wakefield.png",
    name: "Cushman & Wakefield"
};
var AmericanDentalAssociation = {
    url: "/static/img/customers/logos-v2/american_dental_association.png",
    name: "American Dental Association"
};
var Transport = {
    url: "/static/img/customers/logos-v2/transport-for-greater-manchester.png",
    name: "Transport"
};
// const Web = { url: "/static/img/customers/logos-v2/web.com.png", name: "Web" };
var HamiltonLaneAdvisors = {
    url: "/static/img/customers/logos-v2/hamilton_lane_advisors.png",
    name: "Hamilton Land Advisors"
};
// const DineInFreshDbaPlated = {
//   url: "/static/img/customers/logos-v2/dineinfresh_dba_plated.png",
//   name: "DineInFresh"
// };
var SouthTexasCollege = {
    url: "/static/img/customers/logos-v2/south_texas_college.png",
    name: "South Texas College"
};
var LMBopco = {
    url: "/static/img/customers/logos-v2/lmb_opco.png",
    name: "Lmb Opco"
};
// const BBC = {
//   url: "/static/img/customers/logos-v2/bbc.png",
//   name: "BBC"
// };
// const FrankeKitchenSystems = {
//   url: "/static/img/customers/logos-v2/franke_kitchen_systems.png",
//   name: "Franke Kitchen Systems"
// };
var InsightVenturePartners = {
    url: "/static/img/customers/logos-v2/insight_venture_partners.png",
    name: "Insights Venture Partners"
};
// const Kumon = { url: "/static/img/customers/logos-v2/kumon.png", name: "Kumon" };
var LiebermanResearch = {
    url: "/static/img/customers/logos-v2/lieberman_research.png",
    name: "Lieberman Research"
};
var Novocure = {
    url: "/static/img/customers/logos-v2/novocure.png",
    name: "Novocure"
};
// const Tarkett = { url: "/static/img/customers/logos-v2/tarkett.png", name: "Tarkett" };
// const IronSource = { url: "/static/img/customers/logos-v2/ironsource.png",  name: "IronSource" };
// new country logos
var BnpParibas = {
    url: "/static/img/customers/logos-v2/bnpparibas.png",
    name: "BNP Paribas"
};
// const Bosch = {
//   url: "/static/img/customers/logos-v2/bosch.png",
//   name: "Bosch"
// };
var CocaCola = {
    url: "/static/img/customers/logos-v2/coca_cola.png",
    name: "Coca Cola"
};
var CocaColaWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/cocacola.png",
    name: "Coca Cola"
};
var CocaColaBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/cocacola.png",
    name: "Coca Cola"
};
var Globoplay = {
    url: "/static/img/customers/logos-v2/globoplay.png",
    name: "Globoplay"
};
var Loreal = {
    url: "/static/img/customers/logos-v2/loreal.png",
    name: "Loreal"
};
var RaiaDrogasil = {
    url: "/static/img/customers/logos-v2/raia_drogasil.png",
    name: "Raia Drogasil"
};
var Omelete = {
    url: "/static/img/customers/logos-v2/omelete.png",
    name: "Omelete"
};
var Hepmil = {
    url: "/static/img/customers/logos-v2/hempmil.png",
    name: "Hepmil"
};
var Sistic = {
    url: "/static/img/customers/logos-v2/SISTIC-Logo-PNG.png",
    name: "Sistic"
};
var NBC = {
    url: "/static/img/customers/logos-v2/nbc-logo.png",
    name: "NBC"
};
var DiscoveryChannel = {
    url: "/static/img/customers/logos-v2/discovery_channel_logo.png",
    name: "Discovery Channel"
};
var SkyBrasil = {
    url: "/static/img/customers/logos-v2/sky-brasil.jpg",
    name: "Sky Brasil"
};
var Carrefour = {
    url: "/static/img/customers/logos-v2/carrefour.png",
    name: "Carrefour"
};
var CarrefourWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/carrefour.png",
    name: "Carrefour"
};
var CarrefourBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/carrefour.png",
    name: "Carrefour"
};
var Sanofi = {
    url: "/static/img/customers/logos-v2/sanofi.png",
    name: "Sanofi"
};
var Accor = {
    url: "/static/img/customers/logos-v2/accor.png",
    name: "Accor"
};
var Bayer = {
    url: "/static/img/customers/logos-v2/bayer.png",
    name: "Bayer"
};
var Zhdk = {
    url: "/static/img/customers/logos-v2/zhdk.png",
    name: "Zhdk"
};
var Freitag = {
    url: "/static/img/customers/logos-v2/freitag.png",
    name: "Freitag"
};
var PicPay = {
    url: "/static/img/customers/logos-v2/picpay.png",
    name: "PicPay"
};
// const Wildlife = {
//   url: "/static/img/customers/logos-v2/wildlife.png",
//   name: "Wildlife"
// };
// const Magalu = {
//   url: "/static/img/customers/logos-v2/magalu.png",
//   name: "Magalu"
// };
// const Nubank = {
//   url: "/static/img/customers/logos-v2/nubank.png",
//   name: "Nubank"
// };
var BtgPactual = {
    url: "/static/img/customers/logos-v2/btg-pactual.png",
    name: "BtgPactual"
};
// const Ifood = {
//   url: "/static/img/customers/logos-v2/ifood.png",
//   name: "Ifood"
// };
var Wix = {
    url: "/static/img/customers/logos-v2/wix.png",
    name: "Wix"
};
var Eni = {
    url: "/static/img/customers/logos-v2/eni.png",
    name: "Eni"
};
// const Moncler = {
//   url: "/static/img/customers/logos-v2/moncler.png",
//   name: "Moncler"
// };
// const Prometeia = {
//   url: "/static/img/customers/logos-v2/prometeia.png",
//   name: "Prometeia"
// };
var AsRoma = {
    url: "/static/img/customers/logos-v2/as_roma.png",
    name: "AS Roma"
};
var RomaMobilita = {
    url: "/static/img/customers/logos-v2/mobilita.png",
    name: "Roma Mobilita"
};
var SoftwareAG = {
    url: "/static/img/customers/logos-v2/software_ag.png",
    name: "Software AG"
};
var BauerMediaGroup = {
    url: "/static/img/customers/logos-v2/bauer-media-group.png",
    name: "Bauer Media Group"
};
// const NHL = {
//   url: "/static/img/customers/logos-v2/nhl.png",
//   name: "NHL"
// };
// const Hubspot = {
//   url: "/static/img/customers/logos-v2/hubspot.png",
//   name: "Hubspot"
// };
var MarsWrigley = {
    url: "/static/img/customers/logos-v2/mars_wrigley.png",
    name: "Mars Wrigley"
};
var McCan = {
    url: "/static/img/customers/logos-v2/maccan.png",
    name: "McCan"
};
var Canva = {
    url: "/static/img/customers/logos-v2/canva.png",
    name: "Canva"
};
var CanvaWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/canva.png",
    name: "Canva"
};
var CanvaBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/canva.png",
    name: "Canva"
};
// const ElectronicArts = {
//   url: "/static/img/customers/logos-v2/Electronic_Arts.png",
//   name: "Electronic Arts"
// };
// const NBCUniversal = {
//   url: "/static/img/customers/logos-v2/NBCUniversal.png",
//   name: "NBC Universal"
// };
var Movile = {
    url: "/static/img/customers/logos-v2/movile.png",
    name: "Movile"
};
var Riachuelo = {
    url: "/static/img/customers/logos-v2/riachuelo.png",
    name: "Riachuelo"
};
var Even = {
    url: "/static/img/customers/logos-v2/even.png",
    name: "Even"
};
var Playtech = {
    url: "/static/img/customers/logos-v2/playtech.png",
    name: "Playtech"
};
var Datacom = {
    url: "/static/img/customers/logos-v2/datacom.png",
    name: "Datacom"
};
var Lightspeed = {
    url: "/static/img/customers/logos-v2/lightspeed.png",
    name: "Lightspeed"
};
// const Nautica = {
//   url: "/static/img/customers/logos-v2/nautica.png",
//   name: "Nautica"
// };
var Eisai = {
    url: "/static/img/customers/logos-v2/Eisai.png",
    name: "Eisai"
};
var Wella = {
    url: "/static/img/customers/logos-v2/Retail_Wella.png",
    name: "Wella"
};
var NipponGases = {
    url: "/static/img/customers/logos-v2/nippon.png",
    name: "NipponGases"
};
var HoltCat = {
    url: "/static/img/customers/logos-v2/HoltCat.png",
    name: "HoltCat"
};
var HoltCatWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/Holt.png",
    name: "HoltCatWhite"
};
var HoltCatBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/Holt.png",
    name: "HoltCatBlack"
};
var Falk = {
    url: "/static/img/customers/logos-v2/Falk.png",
    name: "Falk"
};
// const Motorola = {
//   url: "/static/img/customers/logos-v2/motorola.png",
//   name: "Motorola"
// };
var Aesop = {
    url: "/static/img/customers/Aesop.png",
    name: "Aesop"
};
var Levis = {
    url: "/static/img/customers/levis.png",
    name: "Levis"
};
var Carlsberg = {
    url: "/static/img/customers/carlsberg.png",
    name: "Carlsberg"
};
var Lionsgate = {
    url: "/static/img/customers/logos-v2/lionsgate.png",
    name: "Lionsgate"
};
var LionsgateWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/lionsgate.png",
    name: "Lionsgate"
};
var LionsgateBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/lionsgate.png",
    name: "Lionsgate"
};
var Herdez = {
    url: "/static/img/customers/logos-v2/herdez.png",
    name: "Herdez"
};
var CruzRuja = {
    url: "/static/img/customers/logos-v2/cruz_ruja.png",
    name: "Cruz Ruja"
};
// const Prosegur = {
//   url: "/static/img/customers/logos-v2/prosegur.png",
//   name: "Prosegur"
// };
var Coppel = {
    url: "/static/img/customers/logos-v2/coppel.png",
    name: "Coppel"
};
var Leboncoin = {
    url: "/static/img/customers/logos-v2/leboncoin.png",
    name: "Leboncoin"
};
var Axa = {
    url: "/static/img/customers/logos-v2/axa.png",
    name: "Axa"
};
var JakartaMRT = {
    url: "/static/img/customers/logos-v2/mrt-lakarta.png",
    name: "Jakarta MRT"
};
var Farfetch = {
    url: "/static/img/customers/logos-v2/farfetch.png",
    name: "Farfetch"
};
var PetLove = {
    url: "/static/img/customers/logos-v2/petlove.png",
    name: "PetLove"
};
var ArytonSenna = {
    url: "/static/img/customers/logos-v2/instituto_ayrton_senna.png",
    name: "Aryton Senna"
};
var Telefonica = {
    url: "/static/img/customers/logos-v2/o2_Telefonica.png",
    name: "Telefonica"
};
var Invitae = {
    url: "/static/img/customers/logos-v2/invitae.png",
    name: "Invitae"
};
var Hesta = {
    url: "/static/img/customers/logos-v2/hesta.png",
    name: "Hesta"
};
var NHS = {
    url: "/static/img/customers/logos-v2/sheffield_health.png",
    name: "NHS"
};
var DavidJones = {
    url: "/static/img/customers/logos-v2/david_jones.png",
    name: "David Jones"
};
var Kmart = {
    url: "/static/img/customers/logos-v2/kmart.png",
    name: "Kmart"
};
var Officeworks = {
    url: "/static/img/customers/logos-v2/officeworks.png",
    name: "Officeworks"
};
var NSW = {
    url: "/static/img/customers/logos-v2/nsw.png",
    name: "NSW"
};
var FlightCentre = {
    url: "/static/img/customers/logos-v2/flight_center.png",
    name: "Flight Centre"
};
var NuroBiz = {
    url: "/static/img/customers/logos-v2/nurobiz.png",
    name: "NuroBiz"
};
var Oxy = {
    url: "/static/img/customers/logos-v2/oxy.png",
    name: "Oxy"
};
var OxyWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/Occidental-Petroleum-Logo_1.png",
    name: "OxyWhite"
};
var OxyBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/Occidental-Petroleum-Logo_1.png",
    name: "OxyBlack"
};
var NutriAsia = {
    url: "/static/img/customers/logos-v2/nutri_asia.png",
    name: "NutriAsia"
};
var VerdantSolar = {
    url: "/static/img/customers/logos-v2/verdant_solar.png",
    name: "VerdantSolar"
};
var HMR = {
    url: "/static/img/customers/logos-v2/hmr-ph-logo.png",
    name: "HMR"
};
var Esker = {
    url: "/static/img/customers/logos-v2/esker.png",
    name: "Oxy"
};
var Takenaka = {
    url: "/static/img/customers/logos-v2/takenaka.png",
    name: "Oxy"
};
var JustCo = {
    url: "/static/img/customers/logos-v2/just_co.png",
    name: "Just Co"
};
var Ebanx = {
    url: "/static/img/customers/logos-v2/EBANX_Logo.png",
    name: "Ebanx"
};
var Entreprenur = {
    url: "/static/img/customers/logos-v2/entrepreneur.png",
    name: "Entreprenur"
};
var Channel4 = {
    url: "/static/img/customers/logos-v2/channel_4.png",
    name: "Channel4"
};
var Nielsen = {
    url: "/static/img/customers/logos-v2/Nielsen.png",
    name: "Nielsen"
};
var WundermanThompson = {
    url: "/static/img/customers/logos-v2/Wunderman_Thompson.png",
    name: "WundermanThompson"
};
var MCSaatchi = {
    url: "/static/img/customers/logos-v2/M_C_Saatchi.png",
    name: "MCSaatchi"
};
var BustleDigitalGroup = {
    url: "/static/img/customers/logos-v2/Bustle.png",
    name: "BustleDigitalGroup"
};
var Frasers = {
    url: "/static/img/customers/logos-v2/FRAS.L.png",
    name: "Frasers"
};
var LondonBoroughOfHaringey = {
    url: "/static/img/customers/logos-v2/Haringey.png",
    name: "LondonBoroughOfHaringey"
};
var TheTravelCorporation = {
    url: "/static/img/customers/logos-v2/the-travel-corporation.png",
    name: "TheTravelCorporation"
};
var RoyalMail = {
    url: "/static/img/customers/logos-v2/Royal_Mail.png",
    name: "RoyalMail"
};
var Cover = {
    url: "/static/img/customers/logos-v2/cover.png",
    name: "Cover"
};
var Hitachi = {
    url: "/static/img/customers/logos-v2/Hitachi.png",
    name: "Hitachi"
};
var HitachiSolutions = {
    url: "/static/img/customers/logos-v2/Hitachi_logo.png",
    name: "Hitachi solutions"
};
var ED = {
    url: "/static/img/customers/logos-v2/3dpc_logo_4.png",
    name: "ED"
};
var Moneytree = {
    url: "/static/img/customers/logos-v2/Moneytree.png",
    name: "Moneytree"
};
var ToyotaConiqAlpha = {
    url: "/static/img/customers/logos-v2/Toyotaconiqalpha.png",
    name: "Toyota Coniq Alpha"
};
var Renault = {
    url: "/static/img/customers/logos-v2/renault_group.png",
    name: "Renault"
};
var Engie = {
    url: "/static/img/customers/logos-v2/engie_logo.png",
    name: "Engie"
};
var JumboSupermarkten = {
    url: "/static/img/customers/logos-v2/Jumbo.png",
    name: "Jumbo"
};
var ErasmusUniversityRotterdam = {
    url: "/static/img/customers/logos-v2/Erasmus.png",
    name: "Erasmus University Rotterdam"
};
var Webfleet = {
    url: "/static/img/customers/logos-v2/wf.png",
    name: "Webfleet"
};
var Hunkemoller = {
    url: "/static/img/customers/logos-v2/Hunkemoeller.png",
    name: "Hunkemoller"
};
var ScotchAndSoda = {
    url: "/static/img/customers/logos-v2/Scotch_Soda.png",
    name: "Scotch & Soda"
};
var RayWhite = {
    url: "/static/img/customers/logos-v2/ray-white.png",
    name: "Ray White"
};
var Flybuys = {
    url: "/static/img/customers/logos-v2/Flybuys.png",
    name: "Flybuys"
};
var Taronga = {
    url: "/static/img/customers/logos-v2/Taronga_zoo.png",
    name: "Taronga Zoo"
};
var NTT = {
    url: "/static/img/customers/logos-v2/ntt-data-logo.png",
    name: "NTT"
};
var Lixil = {
    url: "/static/img/customers/logos-v2/lixil_logo.png",
    name: "Lixil"
};
var Decathlon = {
    url: "/static/img/customers/logos-v2/Retail_Decathlon.png",
    name: "Decathlon"
};
var DavidYurman = {
    url: "/static/img/customers/logos-v2/Retail_David.png",
    name: "David Yurman"
};
var PapaJohns = {
    url: "/static/img/customers/logos-v2/papa_johns.png",
    name: "Papa Johns"
};
var SmartCamp = {
    url: "/static/img/customers/logos-v2/smartcamp-logo.png",
    name: "Smart Camp"
};
var SUNO = {
    url: "/static/img/customers/logos-v2/SUNO.png",
    name: "SUNO"
};
var SportGroup = {
    url: "/static/img/customers/logos-v2/sport_group.png",
    name: "Sports Group"
};
var WelcomeToTheJungle = {
    url: "/static/img/customers/logos-v2/wttj_logo.png",
    name: "Welcome To The Jungle"
};
var Yanmar = {
    url: "/static/img/customers/logos-v2/Yanmar_logo.png",
    name: "Yanmar"
};
var Obayashi = {
    url: "/static/img/customers/logos-v2/obayashi-logo.png",
    name: "Obayashi"
};
var COMPANIES_ASSETS = [
    Uber,
    Oxy,
    FrontierDevelopments,
    Zippo,
    Alexion,
    Anadarko,
    Spinmaster,
    InteriorLogic,
    AmericanFamilyInsurance,
    Deezer,
    Barvado,
    Briggs,
    CarndoChemrisk,
    Canva,
    Glossier,
    Lionsgate,
    AeroMexico,
    ProcoreTechnology,
    Outbrain,
    Emerson,
    CardinalHealth,
    Marriott,
    Mckesson,
    PapaJohns,
    Genpact,
    Kroger,
    Walmart,
    NipponOil,
    ADP,
    BD,
    HCAHealthcare,
    Peloton,
    TennisAustralia,
    Exelon,
    HenrySchein,
    Davita,
    PVH,
    Stryker,
    ThermoFisher,
    Univar,
    UsFoods,
    WestRock,
    Caseys,
    CrossRiverBank,
    PrimonialHolding,
    Prohibition_vapes,
    AlbericiGroup,
    UniversityOfLouisville,
    GamingLabs,
    Terracon,
    VeriskAnalytics,
    CushmanAndWakefield,
    AmericanDentalAssociation,
    Transport,
    HamiltonLaneAdvisors,
    SouthTexasCollege,
    LMBopco,
    Lionsgate,
    InsightVenturePartners,
    LiebermanResearch,
    Novocure,
    BnpParibas,
    CocaCola,
    Globoplay,
    RaiaDrogasil,
    Omelete,
    NBC,
    DiscoveryChannel,
    SkyBrasil,
    Carrefour,
    Sanofi,
    Accor,
    Bayer,
    BtgPactual,
    UniversalMusicGroup,
    Wix
];
var _obj1;
var LOGOS_BY_COUNTRIES = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.BRAZIL, [
    Ebanx,
    CocaCola,
    BtgPactual,
    PicPay,
    SUNO,
    RaiaDrogasil,
    PetLove,
    ArytonSenna,
    Even
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.FRANCE, [
    Uber,
    WelcomeToTheJungle,
    Carrefour,
    Sanofi,
    Renault,
    Engie,
    Leboncoin,
    BnpParibas,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.MEXICO, [
    Herdez,
    UniversalMusicGroup,
    CruzRuja,
    AeroMexico,
    Uber,
    CocaCola,
    Coppel
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.GERMANY, [
    SoftwareAG,
    Wella,
    BauerMediaGroup,
    Uber,
    CocaCola,
    Bayer,
    Axa,
    SportGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.ITALY, [
    Eni,
    AsRoma,
    RomaMobilita,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.JAPAN, [
    NuroBiz,
    Lixil,
    HitachiSolutions,
    NTT,
    Takenaka,
    NipponGases,
    Hitachi,
    ToyotaConiqAlpha,
    ED,
    Uber,
    Yanmar,
    Obayashi,
    Walmart,
    Canva,
    Cover,
    Eisai,
    Zippo,
    UniversalMusicGroup,
    HoltCat,
    CocaCola,
    Moneytree,
    SmartCamp
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.AUSTRALIA, [
    Canva,
    RayWhite,
    DavidJones,
    Kmart,
    Officeworks,
    Taronga,
    Flybuys,
    FlightCentre,
    MCSaatchi,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.SEA, [
    JakartaMRT,
    Canva,
    Sistic,
    NutriAsia,
    VerdantSolar,
    HMR,
    JustCo,
    Hepmil,
    Esker
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.UK, [
    Frasers,
    Lionsgate,
    LondonBoroughOfHaringey,
    TheTravelCorporation,
    Nielsen,
    Outbrain,
    MarsWrigley,
    Bayer,
    RoyalMail
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.NETHERLANDS, [
    JumboSupermarkten,
    ErasmusUniversityRotterdam,
    Webfleet,
    Hunkemoller,
    ScotchAndSoda,
    CocaCola,
    HoltCat,
    UniversalMusicGroup,
    Uber,
    Canva,
    Zippo
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.SWITZERLAND, [
    Carrefour,
    Axa,
    Bayer,
    CocaCola,
    Uber,
    Wella,
    Zhdk,
    Freitag
]), _obj1);
var _obj2;
var LOGOS_BY_CLUSTER = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.HEALTHCARE, [
    CardinalHealth,
    BD,
    HCAHealthcare,
    HenrySchein,
    Stryker,
    Invitae,
    Hesta,
    Alexion,
    NHS
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.ENTERTAINMENT, [
    DiscoveryChannel,
    Entreprenur,
    NBC,
    Deezer,
    Telefonica,
    UniversalMusicGroup,
    Lionsgate,
    Channel4,
    Nielsen,
    SkyBrasil,
    BauerMediaGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.MARKETING, [
    CocaCola,
    McCan,
    UniversalMusicGroup,
    WundermanThompson,
    Wix,
    MarsWrigley,
    Glossier,
    Loreal,
    HoltCat,
    MCSaatchi
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.ENTERPRISE, [
    Wix,
    Oxy,
    MarsWrigley,
    Canva,
    CocaCola,
    Lionsgate,
    Glossier,
    HoltCat,
    BD
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.SOFTWARE, [
    Wix,
    Outbrain,
    Playtech,
    Datacom,
    Lightspeed,
    Canva
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.CONSTRUCTION, [
    HoltCat,
    Falk,
    InteriorLogic,
    AlbericiGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.RETAIL, [
    Kmart,
    Carrefour,
    Peloton,
    Glossier,
    Wella,
    Zippo,
    PVH,
    Decathlon,
    DavidYurman,
    Officeworks,
    Levis,
    Loreal,
    Carlsberg
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL, [
    HoltCat,
    Canva,
    CocaCola,
    Oxy,
    Lionsgate,
    Carrefour,
    BD,
    Glossier,
    UniversalMusicGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_WHITE, [
    HoltCatWhite,
    CarrefourWhite,
    OxyWhite,
    CocaColaWhite,
    CanvaWhite,
    BDWhite,
    GlossierWhite,
    UniversalMusicGroupWhite,
    LionsgateWhite
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_BLACK, [
    HoltCatBlack,
    UniversalMusicGroupBlack,
    CocaColaBlack,
    LionsgateBlack,
    CarrefourBlack,
    BDBlack,
    GlossierBlack,
    OxyBlack,
    CanvaBlack
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_OLD, [
    Uber,
    Carrefour,
    Genpact,
    FrontierDevelopments,
    Zippo,
    Alexion,
    Anadarko
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.CRM, [
    BustleDigitalGroup,
    BD,
    Canva,
    CocaCola,
    Lionsgate
]), _obj2);
var getPersonalizedLogosByVisitorCountryIfNeeded = function(companyField, country, personalizeUsingVisitorCountry, cloudfrontViewerCountry, abTests) {
    var supportedCompanyFields = [
        LOGO_COMPANY_FIELDS.GENERAL
    ];
    if (!supportedCompanyFields.includes(companyField)) {
        return country;
    }
    var fullyReleasedPersonalizedCountries = [
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.UNITED_KINGDOM_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.AUSTRALIA_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.PHILIPPINES_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.SINGAPORE_ISO2
    ];
    if (fullyReleasedPersonalizedCountries.includes(cloudfrontViewerCountry)) {
        return ISO2_TO_LOGO_COUNTRIES_MAP[cloudfrontViewerCountry];
    }
    // TODO: modify for CA logos test
    // const personalizedCountriesInTest = [AUSTRALIA_ISO2];
    // if (personalizedCountriesInTest.includes(cloudfrontViewerCountry)) {
    //   if (personalizeUsingVisitorCountry || shouldGetPersonalizedAuLogosTest(abTests, true)) {
    //     return ISO2_TO_LOGO_COUNTRIES_MAP[cloudfrontViewerCountry];
    //   }
    // }
    return country;
};
var getCompaniesAssets = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var country = options.country, companyField = options.companyField, personalizeUsingVisitorCountry = options.personalizeUsingVisitorCountry, cloudfrontViewerCountry = options.cloudfrontViewerCountry, abTests = options.abTests;
    var firstAssets = [];
    var selectedCountry = getPersonalizedLogosByVisitorCountryIfNeeded(companyField, country, personalizeUsingVisitorCountry, cloudfrontViewerCountry, abTests);
    if (selectedCountry && LOGOS_BY_COUNTRIES[selectedCountry]) {
        firstAssets = LOGOS_BY_COUNTRIES[selectedCountry];
    } else if (companyField && LOGOS_BY_CLUSTER[companyField]) {
        firstAssets = LOGOS_BY_CLUSTER[companyField];
    }
    return lodash_union__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(firstAssets).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(COMPANIES_ASSETS)));
};
var NUMBER_OF_COMPANIES = "9";


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7229,6602,390,8834,5365,657,4397,9359,4858,2300,7905,5657,4494,4961,6430,3211,1360,9952,1314,603,3126,8885,691,9132,1305,9071,3530,9774,2888,179], function() { return __webpack_exec__(11430); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);